var isUsingEvidon = function isUsingEvidon() {
  return !!document.querySelector("script[src*='c.evidon.com']");
};

export default isUsingEvidon;